<template>
    <div class="journalListMargin" v-if="totalJournals != ''">
        <div class="journal__legend_bar"><strong>Холбоотой нийтлэлүүд:</strong></div>
        <div class="row">
            <GenericJournalCard v-for="(journal, index) in totalJournals" :key="index" :journal="journal"/>
        </div>
        <br>
        <div class="load-more-btn">
            <v-btn block class="loadMoreButton" v-if="endPoint" @click="movieJournals(loadMore += 1)">Бусад мэдээнүүд</v-btn>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import GenericJournalCard from '@/components/generics/movie_serial/GenericJournalCard.vue'

export default {
    props: {
        type: String,
        slug: String
    },
    components: {
        GenericJournalCard
    },
    data(){
        return{
            movieSlug: this.slug,
            totalJournals: [],
            journalList: [],
            loadMore: 1,
            endPoint: ''
        }
    },
    methods:{
        movieJournals(){
            var url
            this.type === "movie" ? url = '/movie/api-movie-journals/' : url = '/serial/api-serial-journals/'
            axios
                .get(url, {params: {slug: this.movieSlug, loadMore: this.loadMore}})
                .then(response => {this.journalList = response.data.journals, this.endPoint = response.data.end_point, this.totalJournals = this.totalJournals.concat(this.journalList)})
        }
    },
    created(){
        this.movieJournals()
    },
    watch:{
        slug(){
            this.movieSlug = this.slug
            this.totalJournals = []
            this.journalList = []
            this.loadMore = 1
            this.endPoint = ''
            this.movieJournals()
        }
    }
}
</script>

<style scoped>

.journalListMargin {
    margin: 20px 5px 0;
}

.journal__legend_bar {
    color: #0066b5;
    font-size: 28px;
    text-transform: uppercase;
    font-weight: 300;
    margin: auto;
    width: 100%;
}

.row {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    padding: 0.5rem;
    margin: 0 auto;
    gap: 0.5rem;
}

.loadMoreButton {
    color:#FFFFFF; 
    background-image: linear-gradient(#FFFFFF, #696969);
}

.load-more-btn {
    text-align: center;
}

@media (min-width: 481px) {
    .row {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

</style>